export const blockIconsAndroidRssFeedNew = (
	<span className='material-symbols-outlined'>rss_feed</span>
);
